import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CurrentCustomerDocument, CurrentCustomerQuery } from '@schema';
import { Apollo } from 'apollo-angular';
import { catchError, filter, map, Observable, ReplaySubject } from 'rxjs';
import { CurrentCustomer } from './current-customer.query';

@Injectable()
export class CurrentCustomerService {
  constructor(
    private snackBar: MatSnackBar,
    private readonly apollo: Apollo
  ) {
    this._getCurrentCustomer().subscribe(this._currentCustomer$);
  }

  private _currentCustomer$ = new ReplaySubject<CurrentCustomer>(1);

  public get currentCustomer$() {
    return this._currentCustomer$;
  }

  private _getCurrentCustomer() {
    return this.apollo
      .use('CA')
      .query<CurrentCustomerQuery>({
        query: CurrentCustomerDocument,
      })
      .pipe(
        map(res => res?.data?.customer_current),
        filter(Boolean),
        catchError(err => {
          const message = $localize`There was an unexpected error.`;
          this.snackBar.open(message, $localize`Close`, { duration: 10000 });
          throw err;
        })
      );
  }
}
